import { render, staticRenderFns } from "./freight_config.vue?vue&type=template&id=79c5df7d&scoped=true"
import script from "./freight_config.vue?vue&type=script&lang=js"
export * from "./freight_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c5df7d",
  null
  
)

export default component.exports